"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexWrap = exports.flexShrink = exports.flexGrow = exports.flexFlow = exports.flexDirection = exports.flex = void 0;
exports.flex = {
  patterns: {
    string: '{{value}}'
  },
  properties: 'flex'
};
exports.flexDirection = {
  patterns: {
    string: '{{value}}'
  },
  properties: 'flexDirection'
};
exports.flexFlow = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}'
  },
  properties: 'flexFlow'
};
exports.flexGrow = {
  patterns: {
    number: '{{value}}'
  },
  properties: 'flexGrow'
};
exports.flexShrink = {
  patterns: {
    number: '{{value}}'
  },
  properties: 'flexShrink'
};
exports.flexWrap = {
  patterns: {
    string: '{{value}}'
  },
  properties: 'flexWrap'
};